import React from "react";

function SandTimeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="31"
      viewBox="0 0 24 31"
      fill="none"
    >
      <path
        d="M2.625 0.75C1.58789 0.75 0.75 1.58789 0.75 2.625C0.75 3.66211 1.58789 4.5 2.625 4.5V5.14453C2.625 7.62891 3.61523 10.0137 5.37305 11.7715L9.3457 15.75L5.37305 19.7285C3.61523 21.4863 2.625 23.8711 2.625 26.3555V27C1.58789 27 0.75 27.8379 0.75 28.875C0.75 29.9121 1.58789 30.75 2.625 30.75H4.5H19.5H21.375C22.4121 30.75 23.25 29.9121 23.25 28.875C23.25 27.8379 22.4121 27 21.375 27V26.3555C21.375 23.8711 20.3848 21.4863 18.627 19.7285L14.6543 15.75L18.6328 11.7715C20.3906 10.0137 21.3809 7.62891 21.3809 5.14453V4.5C22.418 4.5 23.2559 3.66211 23.2559 2.625C23.2559 1.58789 22.418 0.75 21.3809 0.75H19.5H4.5H2.625ZM6.375 5.14453V4.5H17.625V5.14453C17.625 6.25781 17.2969 7.33594 16.6875 8.25H7.3125C6.70898 7.33594 6.375 6.25781 6.375 5.14453ZM7.3125 23.25C7.51758 22.9395 7.75781 22.6465 8.02148 22.377L12 18.4043L15.9785 22.3828C16.248 22.6523 16.4824 22.9453 16.6875 23.2559H7.3125V23.25Z"
        fill="#F59E0B"
      />
    </svg>
  );
}

export default SandTimeIcon;
